import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import 'moment/locale/de';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomActionBar from './CustomActionBar';
import MobileWheelTimePicker from './MobileWheelTimePicker';
import WheelTimePicker from './WheelTimePicker';

const TimeOnlyView = ({ startDate, setStartDate, setStartValue, endDate, setEndDate, setEndValue, shouldUpdate, setUpdated }) => {

    const theme = useTheme();
    const belowsm = useMediaQuery(theme.breakpoints.down("sm"));

    const [date, setDate] = useState([
        moment(),
        moment()
    ]);
    const [dateRange, setDateRange] = useState([
        moment(),
        moment()
    ])
    const [openDate, setOpenDate] = useState(false);

    const { t } = useTranslation();

    useEffect(() => {
        if (moment(endDate).diff(moment(startDate), "hours") > 23 && shouldUpdate) {
            const startDateAsMoment = moment(startDate);
            const endDateForMeeting = moment(startDate);
            endDateForMeeting.set("hour", moment(endDate).hours());
            endDateForMeeting.set("minute", moment(endDate).minutes());
            if (startDateAsMoment.minutes() === endDateForMeeting.minutes() && startDateAsMoment.hours() === endDateForMeeting.hours() && startDateAsMoment.format("HH:mm") !== "23:45") {
                endDateForMeeting.add(15, "minute");
            }
            setDate([
                startDateAsMoment,
                endDateForMeeting
            ])
            setDateRange([
                startDateAsMoment,
                endDateForMeeting
            ])
            setEndDate(endDateForMeeting);
            setEndValue(endDateForMeeting);
        };
        setDate([
            startDate,
            endDate
        ])
        setDateRange([
            startDate,
            endDate
        ]);
        //eslint-disable-next-line
    }, [startDate, endDate])

    // Falls bugs auftreten im wechsel von date-only zo time-only Ansagen, hier ansetzen (nicht fertig durchdacht)
    // useEffect(() => {
    //     const startDateAsMoment = moment(startDate);
    //     let endDateAsMoment = moment(endDate);

    //     // Normalize stale ranges when switching from date-based announcements:
    //     // preselect end time as start + 15 minutes in time-only mode.
    //     const mustNormalizeEndTime = shouldUpdate && (
    //         endDateAsMoment.diff(startDateAsMoment, "hours") > 23 ||
    //         !endDateAsMoment.isAfter(startDateAsMoment)
    //     );

    //     if (mustNormalizeEndTime) {
    //         endDateAsMoment = moment(startDateAsMoment).add(15, "minute");
    //         setEndDate(endDateAsMoment);
    //         setEndValue(endDateAsMoment);
    //     }

    //     setDate([
    //         startDateAsMoment,
    //         endDateAsMoment
    //     ]);
    //     setDateRange([
    //         startDateAsMoment,
    //         endDateAsMoment
    //     ]);
    //     //eslint-disable-next-line
    // }, [startDate, endDate, shouldUpdate])

    const setStartTime = (startTime) => {
        const newTime = moment(startTime);
        const newEndTime = moment(startTime);
        const diff = date[1].diff(date[0], "minute");
        newEndTime.add(diff, "minute");
        const newArr = [
            newTime,
            newEndTime
        ]
        setDate(newArr);
        setStartDate(newTime);
        setStartValue(newTime);
        setEndDate(newEndTime);
        setEndValue(newEndTime);
    };

    const setEndTime = (endTime) => {
        const newTime = moment(endTime);
        const newStartTime = moment(endTime);
        const isBefore = newTime.isBefore(date[0]);
        if (isBefore && newTime.format("HH:mm") !== "00:00") {
            newStartTime.subtract(15, "minute");
        }
        const newArr = [
            isBefore ? newStartTime : date[0],
            newTime
        ]
        setDate(newArr);
        if (isBefore) {
            setStartDate(newStartTime);
            setStartValue(newStartTime);
        }
        setEndDate(newTime)
        setEndValue(newTime);
    };

    const Seperator = () => {

        return (
            <Box
                sx={{ display: 'inline-block', transform: 'scale(1.2)', pl: 1.5, pt: 1 }}
            >
                _
            </Box>
        )
    };

    return (
        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={localStorage.getItem("i18nextLng")}>
            <Grid
                item
                xs={3}
                sx={{
                    p: 1,
                    pb: 2,
                    ml: 1
                }}
            >
                <Grid container>
                    <Grid item xs={12}>
                        <DatePicker
                            label={t("date")}
                            format="DD.MM.YYYY"
                            value={dateRange[0] || moment()}
                            open={openDate}
                            onClose={() => { setOpenDate(false); }}
                            onChange={(newDate) => {
                                if (newDate !== null) {
                                    let arr = [];
                                    const diff = moment(newDate).diff(startDate);
                                    const endDateAsMoment = moment(endDate).add(diff);
                                    // const dayDifference = moment(newDate).diff(startDate, "day", true);
                                    // console.log(dayDifference)
                                    // if (dayDifference > 1) {
                                    //     endDateAsMoment.subtract(Math.trunc(dayDifference), "days");
                                    // }
                                    // if (dayDifference < -1) {
                                    //     endDateAsMoment.add(Math.trunc(dayDifference), "days");
                                    // }
                                    arr.push(newDate);
                                    arr.push(endDate);
                                    setStartDate(newDate);
                                    setStartValue(newDate);
                                    setDate(arr);
                                    setEndDate(endDateAsMoment);
                                    setEndValue(endDateAsMoment);
                                    if (setUpdated) {
                                        setUpdated(true);
                                    }
                                }
                            }}
                            slots={{
                                actionBar: CustomActionBar,
                            }}
                            slotProps={{
                                textField: {
                                    onClick: () => { setOpenDate(!openDate) },
                                    inputProps: {
                                        readOnly: true
                                    },
                                    InputLabelProps: {
                                        shrink: true
                                    }
                                },
                                desktopPaper: {
                                    sx: {
                                        backgroundImage: "none"
                                    }
                                },
                                mobilePaper: {
                                    sx: {
                                        pt: 2,
                                        borderRadius: 6,
                                        backgroundImage: "none"
                                    }
                                },
                                toolbar: {
                                    hidden: true
                                }
                            }}
                            sx={{
                                width: "100%"
                            }}
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid
                item
                xs={3}
                sx={{
                    p: 1,
                    pt: 0,
                    ml: 1,
                }}
            >
                <Grid container>
                    <Grid item xs={5.5} sx={{ pr: .5 }}>
                        {
                            belowsm ?
                                <MobileWheelTimePicker label={t("start-time")} time={date[0]} setTime={setStartTime} setUpdated={setUpdated} /> :
                                <WheelTimePicker label={t("start-time")} showIcon={true} value={date[0]} setValue={setStartTime} setUpdated={setUpdated} />
                        }
                    </Grid>
                    <Grid item xs={1} sx={{ visibility: "hidden" }}>
                        <Seperator />
                    </Grid>
                    <Grid item xs={5.5} sx={{ pl: .5 }}>
                        {
                            belowsm ?
                                <MobileWheelTimePicker label={t("end-time")} time={date[1]} setTime={setEndTime} setUpdated={setUpdated} /> :
                                <WheelTimePicker label={t("end-time")} showIcon={true} value={date[1]} setValue={setEndTime} setUpdated={setUpdated} />
                        }
                    </Grid>
                </Grid>
            </Grid>
        </LocalizationProvider>
    );

};

export default TimeOnlyView;
